import LayoutPortal from './layouts/Portal.vue'
import ModuleMixin from './shared/mixins/ModuleMixin';
import ManageStoreMixin from './shared/mixins/ManageStoreMixin';
import GlobalMixin from '@/app/shared/mixins/global';
import { mapGetters } from 'vuex';
import UserIcon from '@images/icon-user.png';

export default {
    mixins: [
        GlobalMixin,
        ModuleMixin,
        ManageStoreMixin,
    ],
    components: {
        ButtonsFooter: () => import(/* webpackChunkName: "buttons-footer" */ '@/app/shared/components/manage/ManageButtonsFooter'),
        LayoutPortal: LayoutPortal,
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters({
            locale: 'localeCode',
        }),
    },
    methods: {
        getImageUser(img) {
            return img ? this.getFormatUrlAPI(img) : UserIcon;
        },
    },
}
